// extracted by mini-css-extract-plugin
module.exports = {"button":"_30Qql54C4GgvH1RszkCquX","tooltipText":"_1z0h-6ipNfnkLxUX8dUBMC","buttonArrow":"_1jv0kGWjb6pKQALTSGXIYq","icon":"_24_n8Mv02OAGPDo4DSioRe"};